function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import amplitude from 'amplitude-js';
export var ApiKey = {
  development: 'e47fd687db6356aa118e0359bb93c3e6',
  production: ''
};
export var DefaultOptions = {
  plan: {
    version: '5',
    branch: 'main',
    source: 'none',
    versionId: '7461e022-2859-412d-a02a-328baac94579'
  }
};
export var Identify = _createClass(function Identify(event_properties) {
  _classCallCheck(this, Identify);

  _defineProperty(this, "event_type", 'Identify');

  this.event_properties = event_properties;
});
export var Group = _createClass(function Group() {
  _classCallCheck(this, Group);

  _defineProperty(this, "event_type", 'Group');
});
export var Ampli = function () {
  function Ampli() {
    _classCallCheck(this, Ampli);

    _defineProperty(this, "disabled", false);

    _defineProperty(this, "middlewares", []);
  }

  _createClass(Ampli, [{
    key: "client",
    get: function get() {
      this.isInitializedAndEnabled();
      return this.amplitude;
    }
  }, {
    key: "isLoaded",
    get: function get() {
      return this.amplitude != null;
    }
  }, {
    key: "isInitializedAndEnabled",
    value: function isInitializedAndEnabled() {
      if (!this.isLoaded) {
        console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
        return false;
      }

      return !this.disabled;
    }
  }, {
    key: "load",
    value: function load(options) {
      var _options$disabled, _options$environment, _options$client$apiKe, _options$client, _options$client2;

      this.disabled = (_options$disabled = options === null || options === void 0 ? void 0 : options.disabled) !== null && _options$disabled !== void 0 ? _options$disabled : false;

      if (this.isLoaded) {
        console.warn('WARNING: Ampli is already initialized. Ampli.load() should be called once at application startup.');
        return;
      }

      var env = (_options$environment = options === null || options === void 0 ? void 0 : options.environment) !== null && _options$environment !== void 0 ? _options$environment : 'development';
      var apiKey = (_options$client$apiKe = options === null || options === void 0 ? void 0 : (_options$client = options.client) === null || _options$client === void 0 ? void 0 : _options$client.apiKey) !== null && _options$client$apiKe !== void 0 ? _options$client$apiKe : ApiKey[env];

      if (options !== null && options !== void 0 && (_options$client2 = options.client) !== null && _options$client2 !== void 0 && _options$client2.instance) {
        var _options$client3;

        this.amplitude = options === null || options === void 0 ? void 0 : (_options$client3 = options.client) === null || _options$client3 === void 0 ? void 0 : _options$client3.instance;
      } else if (apiKey) {
        var _this$amplitude, _options$client4;

        this.amplitude = amplitude.getInstance();
        (_this$amplitude = this.amplitude) === null || _this$amplitude === void 0 ? void 0 : _this$amplitude.init(apiKey, undefined, _objectSpread(_objectSpread({}, DefaultOptions), options === null || options === void 0 ? void 0 : (_options$client4 = options.client) === null || _options$client4 === void 0 ? void 0 : _options$client4.options));
      } else {
        console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
      }
    }
  }, {
    key: "identify",
    value: function identify(userId, properties, options, extra) {
      var _this = this;

      if (!this.isInitializedAndEnabled()) {
        return;
      }

      var event = {
        event_type: SpecialEventType.Identify,
        event_properties: properties,
        user_id: userId || (options === null || options === void 0 ? void 0 : options.user_id),
        device_id: options === null || options === void 0 ? void 0 : options.device_id
      };
      this.runMiddleware({
        event: event,
        extra: extra
      }, function (payload) {
        var _this$amplitude4;

        var e = payload.event;

        if (e.user_id) {
          var _this$amplitude2;

          (_this$amplitude2 = _this.amplitude) === null || _this$amplitude2 === void 0 ? void 0 : _this$amplitude2.setUserId(e.user_id);
        }

        if (e.device_id) {
          var _this$amplitude3;

          (_this$amplitude3 = _this.amplitude) === null || _this$amplitude3 === void 0 ? void 0 : _this$amplitude3.setDeviceId(e.device_id);
        }

        var amplitudeIdentify = new amplitude.Identify();

        if (e.event_properties != null) {
          for (var _i = 0, _Object$entries = Object.entries(e.event_properties); _i < _Object$entries.length; _i++) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
                _key = _Object$entries$_i[0],
                value = _Object$entries$_i[1];

            amplitudeIdentify.set(_key, value);
          }
        }

        (_this$amplitude4 = _this.amplitude) === null || _this$amplitude4 === void 0 ? void 0 : _this$amplitude4.identify(amplitudeIdentify, options === null || options === void 0 ? void 0 : options.callback);
      });
    }
  }, {
    key: "setGroup",
    value: function setGroup(name, value, options, extra) {
      var _this$amplitude5;

      if (!this.isInitializedAndEnabled()) {
        return;
      }

      (_this$amplitude5 = this.amplitude) === null || _this$amplitude5 === void 0 ? void 0 : _this$amplitude5.setGroup(name, value);
    }
  }, {
    key: "groupIdentify",
    value: function groupIdentify(groupType, groupName, options, extra) {
      var _this2 = this;

      if (!this.isInitializedAndEnabled()) {
        return;
      }

      var event = {
        event_type: SpecialEventType.Group,
        user_id: options === null || options === void 0 ? void 0 : options.user_id,
        device_id: options === null || options === void 0 ? void 0 : options.device_id
      };
      this.runMiddleware({
        event: event,
        extra: extra
      }, function (payload) {
        var _this2$amplitude3;

        var e = payload.event;

        if (e.user_id) {
          var _this2$amplitude;

          (_this2$amplitude = _this2.amplitude) === null || _this2$amplitude === void 0 ? void 0 : _this2$amplitude.setUserId(e.user_id);
        }

        if (e.device_id) {
          var _this2$amplitude2;

          (_this2$amplitude2 = _this2.amplitude) === null || _this2$amplitude2 === void 0 ? void 0 : _this2$amplitude2.setDeviceId(e.device_id);
        }

        var amplitudeIdentify = new amplitude.Identify();

        if (e.event_properties != null) {
          for (var _i2 = 0, _Object$entries2 = Object.entries(e.event_properties); _i2 < _Object$entries2.length; _i2++) {
            var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
                _key2 = _Object$entries2$_i[0],
                value = _Object$entries2$_i[1];

            amplitudeIdentify.set(_key2, value);
          }
        }

        (_this2$amplitude3 = _this2.amplitude) === null || _this2$amplitude3 === void 0 ? void 0 : _this2$amplitude3.groupIdentify(groupType, groupName, amplitudeIdentify, options === null || options === void 0 ? void 0 : options.callback);
      });
    }
  }, {
    key: "track",
    value: function track(event, options, extra) {
      var _this3 = this;

      if (!this.isInitializedAndEnabled()) {
        return;
      }

      this.runMiddleware({
        event: event,
        extra: extra
      }, function (payload) {
        var _this3$amplitude;

        (_this3$amplitude = _this3.amplitude) === null || _this3$amplitude === void 0 ? void 0 : _this3$amplitude.logEvent(payload.event.event_type, payload.event.event_properties, options === null || options === void 0 ? void 0 : options.callback);
      });
    }
  }, {
    key: "addEventMiddleware",
    value: function addEventMiddleware(middleware) {
      this.middlewares.push(middleware);
    }
  }, {
    key: "runMiddleware",
    value: function runMiddleware(payload, next) {
      var _this4 = this;

      var curMiddlewareIndex = -1;
      var middlewareCount = this.middlewares.length;

      var middlewareNext = function middlewareNext(curPayload) {
        curMiddlewareIndex += 1;

        if (curMiddlewareIndex < middlewareCount) {
          _this4.middlewares[curMiddlewareIndex](curPayload, _next);
        } else {
          next(curPayload);
        }
      };

      var _next = middlewareCount > 0 ? middlewareNext : next;

      _next(payload);
    }
  }]);

  return Ampli;
}();
export var ampli = new Ampli();
export var SpecialEventType;

(function (SpecialEventType) {
  SpecialEventType["Identify"] = "Identify";
  SpecialEventType["Group"] = "Group";
})(SpecialEventType || (SpecialEventType = {}));
//# sourceMappingURL=index.js.map